// extracted by extract-css-chunks-webpack-plugin
module.exports = {"nav":"nav_jxNPm"};